/**
 * Design System Color Palette
 * TradeBotX-inspired crypto trading dashboard
 */

const colors = {
  dark: {
    // Backgrounds
    bgPrimary: '#060611',
    bgSecondary: '#0A0A1B',
    bgCard: '#0F0F23',
    bgCardHover: '#141432',
    bgSidebar: '#0A0A1B',
    bgInput: '#0F0F23',
    bgElevated: '#16163A',
    bgOverlay: 'rgba(6, 6, 17, 0.85)',

    // Borders
    borderPrimary: 'rgba(99, 102, 241, 0.12)',
    borderSecondary: 'rgba(139, 92, 246, 0.08)',
    borderAccent: 'rgba(99, 102, 241, 0.3)',

    // Text
    textPrimary: '#E8E4F0',
    textSecondary: '#8B83A8',
    textMuted: '#5A5478',
    textInverse: '#060611',

    // Accent
    accentPrimary: '#6366F1',
    accentSecondary: '#8B5CF6',
    accentTertiary: '#A78BFA',
    accentGlow: 'rgba(99, 102, 241, 0.25)',
    gradient: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 50%, #A78BFA 100%)',
    gradientSubtle: 'linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(139, 92, 246, 0.15) 100%)',

    // Semantic
    success: '#10B981',
    successBg: 'rgba(16, 185, 129, 0.12)',
    warning: '#F59E0B',
    warningBg: 'rgba(245, 158, 11, 0.12)',
    error: '#EF4444',
    errorBg: 'rgba(239, 68, 68, 0.12)',
    info: '#3B82F6',
    infoBg: 'rgba(59, 130, 246, 0.12)',

    // Chart colors
    chart: ['#6366F1', '#8B5CF6', '#EC4899', '#F59E0B', '#10B981', '#3B82F6', '#F97316', '#06B6D4'],
  },

  light: {
    bgPrimary: '#F5F6FA',
    bgSecondary: '#FFFFFF',
    bgCard: '#FFFFFF',
    bgCardHover: '#F8F9FC',
    bgSidebar: '#FFFFFF',
    bgInput: '#F5F6FA',
    bgElevated: '#F0F1F8',
    bgOverlay: 'rgba(0, 0, 0, 0.5)',

    borderPrimary: 'rgba(99, 102, 241, 0.15)',
    borderSecondary: '#E5E7EB',
    borderAccent: 'rgba(99, 102, 241, 0.4)',

    textPrimary: '#1A1A2E',
    textSecondary: '#64648C',
    textMuted: '#9494B0',
    textInverse: '#FFFFFF',

    accentPrimary: '#6366F1',
    accentSecondary: '#7C3AED',
    accentTertiary: '#8B5CF6',
    accentGlow: 'rgba(99, 102, 241, 0.15)',
    gradient: 'linear-gradient(135deg, #6366F1 0%, #7C3AED 50%, #8B5CF6 100%)',
    gradientSubtle: 'linear-gradient(135deg, rgba(99, 102, 241, 0.08) 0%, rgba(124, 58, 237, 0.08) 100%)',

    success: '#059669',
    successBg: 'rgba(5, 150, 105, 0.1)',
    warning: '#D97706',
    warningBg: 'rgba(217, 119, 6, 0.1)',
    error: '#DC2626',
    errorBg: 'rgba(220, 38, 38, 0.1)',
    info: '#2563EB',
    infoBg: 'rgba(37, 99, 235, 0.1)',

    chart: ['#6366F1', '#7C3AED', '#DB2777', '#D97706', '#059669', '#2563EB', '#EA580C', '#0891B2'],
  },
};

export default colors;
